export default function ProgressBar({ width }) {
  return (
    <div
      style={{ width: `${width}%`, height: `8px` }}
      className="fixed z-50 bg-gradient-to-r from-red-600 to-yellow-500 transition ease-in-out"
    ></div>
  );
}
